import searchableMultiSelect from "./searchableMultiSelect.component";

const searchableMultiSelectModule = angular
  .module("app.components.searchableMultiSelect", [])
  .component("searchableMultiSelect", searchableMultiSelect);

export default searchableMultiSelectModule;



// WEBPACK FOOTER //
// ./src/components/searchableMultiSelect/searchableMultiSelect.module.js